import Cybernetic from './assets/Cybernetic.png';
import Atlantis from './assets/Atlantis.png';
import Axxess from './assets/Axxess.png';
import HardRockBet from './assets/hardrock_bet-rewards.webp';
import Nextiva from './assets/Nextiva.png';
import Density from './assets/Density.png';
import Insurance from './assets/Insurance.png';

//keep at 6 objects

export const WEBPORT = [
    {
        company: 'Atlantis<br/>Scuba',
        skillsUsed: 'React, HTML, SCSS, Javascript, Figma, Git',
        copy: 'Built to be fun, easy to navigate, and packed with everything you need without the clutter. Started in vanilla HTML, SCSS, and JavaScript then rebuilt into React, a great excuse to get my hands dirty with it.',
        img: Atlantis,
        link: 'https://atlantisscuba.com/',
        updated: false,
        updateCopy: '',
        identity: 'as-content'
    },
    {
        company: 'Luminant<br/>Music',
        skillsUsed: 'HTML, SCSS, JavaScript, Git',
        copy: 'A full overhaul for a startup called Cybernetic Entertainment. The product is visual eye candy for your music, so the site needed to match that energy, bold, immersive, and impossible to scroll past.',
        img: Cybernetic,
        link: 'https://cofcsave.github.io/cybernetic/',
        updated: true,
        updateCopy: 'They are no longer around unfortunately but here\'s a link what I originally created.',
        identity: 'lm-content'
    },
    {
        company: 'Hard Rock Bet',
        skillsUsed: 'HTML, SCSS, Javascript, Figma, Git, Github, Wordpress',
        copy: 'I\'ve been slowly taking this site over, redesigning text-heavy pages into cleaner, better experiences. One of those rare gigs where I get to own both the design and the code with real autonomy.',
        img: HardRockBet,
        link: 'https://hardrock.bet',
        updated: false,
        updateCopy: '',
        identity: 'hrb-content'
    },
    {
        company: 'Nextiva',
        skillsUsed: 'HTML, SCSS, PHP, JavaScript, Figma, GSAP and tiny bit of WordPress',
        copy: 'This one taught me a lot — accessibility, working with a larger dev team and how to have a little fun with performance. Rebuilt their heavy Lottie animations in GSAP and watched the performance scores thank me for it.',
        img: Nextiva,
        link: 'https://web.archive.org/web/20231203114356/https://www.nextiva.com/products/productivity.html',
        updated: true,
        updateCopy: 'They have since transferred fully to Wordpress and redesigned the entire site but above is the link to what I originally created via Wayback Machine',
        identity: 'n-content'
    },
    {
        company: 'Density',
        skillsUsed: 'Webflow, Figma, HTML, CSS',
        copy: 'Not my usual vanilla code setup, but honestly? Figuring out Webflow\'s quirks and limitations turned into a fun puzzle. Came out the other side knowing exactly what it can do and how to push it further.',
        img: Density,
        link: 'https://www.density.io/',
        updated: false,
        updateCopy: '',
        identity: 'd-content'
    },
    {
        company: 'Quote<br/>Friendly',
        skillsUsed: 'HTML, SCSS, JavaScript, AdobeXD',
        copy: 'A Florida insurance company that needed a clean, no-nonsense web presence, fast to load, easy to use, and built to capture leads without getting in anyone\'s way.',
        img: Insurance,
        link: 'https://cofcsave.github.io/quoteFriendly/',
        updated: true,
        updateCopy: 'They have since sold their branch and the buyer had their own site so this one was taken down. The above link is the fully built site before it was taken down.',
        identity: 'qf-content'
    }
  ];
  
